import React, {
  ChangeEventHandler,
  Dispatch,
  MouseEventHandler,
  RefObject,
  SetStateAction,
  useRef,
} from 'react';
import { fileAsString } from '../../../../utils';
import { ModalConfig, useModal } from './modals/modal';
import { PlusIcon } from '@heroicons/react/solid';

interface FileInputProps {
  buttonText: string;
  modalConfig: ModalConfig;
  setFileText: Dispatch<SetStateAction<string | null>>;
}

const FileInputWithModal = ({
  buttonText,
  modalConfig,
  setFileText,
}: FileInputProps) => {
  const [modalRender, popup] = useModal();
  const inputRef: RefObject<HTMLInputElement> = useRef(null);

  const onClick: MouseEventHandler = async e => {
    e.preventDefault();

    const cont = await popup(modalConfig);
    if (cont && inputRef.current) {
      inputRef.current.click();
    }
  };

  const onInputChange: ChangeEventHandler<HTMLInputElement> = async e => {
    const fileText = await fileAsString(e.target.files![0]);
    setFileText(fileText);
  };

  return (
    <div className="flex w-full mt-1">
      {modalRender}
      <button
        onClick={onClick}
        className="w-full cursor-pointer py-2 border border-solid border-blue-primary rounded-lg shadow-sm text-sm text-blue-primary hover:text-blue-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light"
      >
        <PlusIcon className="inline-block mb-[0.2rem] mr-1 w-4 h-4" />
        {buttonText}
      </button>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={onInputChange}
      />
    </div>
  );
};

export default FileInputWithModal;
